import React from 'react'
import Footer from './Footer';
import gal1 from '../img/gal1.jpg'
import gal2 from '../img/gal2.jpg'
import gal3 from '../img/gal3.jpg'
import gal4 from '../img/gal4.jpg'
import gal5 from '../img/gal5.jpg'

import gal6 from '../img/gal6.jpg'
import gal7 from '../img/gal7.jpg'
import gal8 from '../img/gal8.jpg'
import gal9 from '../img/gal9.jpg'
import gal10 from '../img/gal10.jpg'
import gal11 from '../img/gal11.jpg'
import gal12 from '../img/gal12.jpg'
import gal13 from '../img/gal13.jpg'
import gal14 from '../img/gal14.jpg'
import gal15 from '../img/gal15.jpg'
import gal16 from '../img/gal16.jpg'
import gal17 from '../img/gal17.jpg'
import gal18 from '../img/gal18.jpg'
import gal19 from '../img/gal19.jpg'
import gal20 from '../img/gal20.jpg'



import l1 from '../img/l1.jpg'
import l2 from '../img/l2.jpg'
import l3 from '../img/l3.jpg'
import l4 from '../img/l4.jpg'
import l5 from '../img/l5.jpg'
import l6 from '../img/l6.jpg'
import l7 from '../img/l7.jpg'
import l8 from '../img/l8.jpg'
import l9 from '../img/l9.jpg'



import c1 from '../img/c1.jpg'
import c2 from '../img/c2.jpg'
import c3 from '../img/c3.jpg'
import c4 from '../img/c4.jpg'
import c5 from '../img/c5.jpg'
import c6 from '../img/c6.jpg'
import c7 from '../img/c7.jpg'
import c8 from '../img/c8.jpg'
import c9 from '../img/c9.jpg'
import c10 from '../img/c10.jpg'
import c11 from '../img/c11.jpg'
import c12 from '../img/c12.jpg'
import c13 from '../img/c13.jpg'
import c14 from '../img/c14.jpg'


import m1 from '../img/m1.jpg'
import m2 from '../img/m2.jpg'
import m3 from '../img/m3.jpg'
import m4 from '../img/m4.jpg'
import m5 from '../img/m5.jpg'
import m6 from '../img/m6.jpg'
import m7 from '../img/m7.jpg'
import m8 from '../img/m8.jpg'
import m9 from '../img/m9.jpg'





const Gallery = () => {
    return (
        <>
            <div className='heading'>
                <h1>GALLERY </h1>
                <p>Home / Gallery </p>
            </div>

            <div className='gallery'>
                <div className='gallery2'>
                    <img src={gal6} />
                </div>
                <div className='gallery2'>
                    <img src={gal7} />
                </div>
                <div className='gallery2'>
                    <img src={gal8} />
                </div>
            </div>


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={gal9} />
                </div>
                <div className='gallery2'>
                    <img src={gal10} />
                </div>
                <div className='gallery2'>
                    <img src={gal11} />
                </div>
            </div>



            <div className='gallery'>
                <div className='gallery2'>
                    <img src={gal12} />
                </div>
                <div className='gallery2'>
                    <img src={gal13} />
                </div>
                <div className='gallery2'>
                    <img src={gal14} />
                </div>
            </div>




            <div className='gallery'>
                <div className='gallery2'>
                    <img src={gal15} />
                </div>
                <div className='gallery2'>
                    <img src={gal16} />
                </div>
                <div className='gallery2'>
                    <img src={gal17} />
                </div>
            </div>

            <div className='gallery'>
                <div className='gallery2'>
                    <img src={gal8} />
                </div>
                <div className='gallery2'>
                    <img src={gal19} />
                </div>
                <div className='gallery2'>
                    <img src={gal20} />
                </div>
            </div>

            <div className='gallery'>
                <div className='gallery2'>
                    <img src={gal1} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={gal5} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={gal3} style={{ width: '100%' }} />
                </div>
            </div>


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={gal1} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={gal2} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={gal3} style={{ width: '100%' }} />
                </div>
            </div>

            <br />
            <h2 className='text-center mt-3' style={{ fontStyle: "italic", color: ' #881312' }}>
                Laparoscopic Surgeries
            </h2>
            <br />


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={l1} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={l2} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={l3} style={{ width: '100%' }} />
                </div>
            </div>

            <div className='gallery'>
                <div className='gallery2'>
                    <img src={l4} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={l5} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={l6} style={{ width: '100%' }} />
                </div>
            </div>


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={l7} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={l8} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={l9} style={{ width: '100%' }} />
                </div>
            </div>


            <br />
            <h2 className='text-center mt-3' style={{ fontStyle: "italic", color: ' #881312' }}>
                Newborn Baby Photoshoot
            </h2>
            <br />


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={c1} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={c2} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={c3} style={{ width: '100%' }} />
                </div>
            </div>


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={c4} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={c5} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={c6} style={{ width: '100%' }} />
                </div>
            </div>



            <div className='gallery'>
                <div className='gallery2'>
                    <img src={c7} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={c8} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={c9} style={{ width: '100%' }} />
                </div>
            </div>


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={c10} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={c11} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={c12} style={{ width: '100%' }} />
                </div>
            </div>






            <div className='gallery'>
                <div className='gallery2'>
                    <img src={m1} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={m2} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={m3} style={{ width: '100%' }} />
                </div>
            </div>

            <div className='gallery'>
                <div className='gallery2'>
                    <img src={m4} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={m5} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={m6} style={{ width: '100%' }} />
                </div>
            </div>


            <div className='gallery'>
                <div className='gallery2'>
                    <img src={m7} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>
                    <img src={m8} style={{ width: '100%' }} />
                </div>
                <div className='gallery2'>

                    <img src={m9} style={{ width: '100%' }} />
                </div>
            </div>






            <br />
            <Footer />
        </>
    )
}

export default Gallery

